export default {
  "userReport.tooltip.copy.userno": "复制用户编号: {text}",
  "userReport.tooltip.showUserDetails": "显示用户详情",
  "userReport.thead.userno": "会员ID",
  "userReport.thead.statisticsTime": "统计日期",
  "userReport.thead.statisticsTimeFrom": "开始时间",
  "userReport.thead.statisticsTimeTo": "结束时间",
  "userReport.thead.statisticsType": "报表周期",
  "userReport.thead.gameType": "游戏类型",
  "userReport.thead.whatsapp": "whatsapp",
  "userReport.thead.channel": "渠道号",
  "userReport.thead.depositFee": "存款手续费",
  "userReport.thead.depositAmountFeeDiff": "存款减手续费",
  "userReport.thead.depositAmount": "存款",
  "userReport.thead.withdrawFee": "提款手续费",
  "userReport.thead.withdrawAmountFeeDiff": "提款减手续费",
  "userReport.thead.withdrawAmount": "取款",
  "userReport.thead.depositWithdrawDiff": "存-取",
  "userReport.thead.depositWithdrawFeeDiff": "扣除手续费的存-取",
  "userReport.thead.betAmount": "投注",
  "userReport.thead.realBetAmount": "有效投注",
  "userReport.thead.winBetAmountDiff": "派彩",
  "userReport.thead.promotionAmount": "优惠",
  "userReport.thead.cashbackAmount": "返水",
  "userReport.thead.bonusAmount": "奖金",
  "userReport.thead.adminAmount": "修正",
  "userReport.thead.balanceAmount": "余额",
  "userReport.thead.balanceSubAmount": "余额差值",
  "userReport.thead.gainAmount": "盈亏",
  "userReport.thead.reportUpdateTime": "报告时间",
};
